import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants';
import { Platform } from 'react-native';
import { compareVersions } from '../../utils/compareVersions';
import api from './../axios';
import { logError, logInfo } from '../../utils/logHandling';

const os = Platform.OS === 'web' ? 'browser' : Platform.OS;
const app = Constants.expoConfig?.extra?.mode;
const DEFAULT_MIN_VERSION = '0.0.1'; // default minimum version for the app

export const checkAppVersion = () => {
  return api
    .get(`/api/versioninfo?os=${os}&app=${app}`)
    .then(async (res) => {
      if (res.data) {
        // Save minVersion to AsyncStorage
        try {
          await AsyncStorage.setItem(
            'minimumAppVersion',
            res.data.minimumVersion,
          );
          //res.data.latestVersion = "1.6.0";
          await compareVersions(res.data);
        } catch (error) {
          logError('Error setting minimum version in AsyncStorage:', error);
        }
      }
      return res;
    })
    .catch(async () => {
      // Fetching from API failed, try to get the minimum version from AsyncStorage
      try {
        const storedMinVersion =
          await AsyncStorage.getItem('minimumAppVersion');
        if (storedMinVersion) {
          await compareVersions({
            minimumVersion: storedMinVersion,
            latestVersion: '',
          });
        } else {
          logInfo(
            'No minimum version found in AsyncStorage, using default version.',
          );
          await compareVersions({
            minimumVersion: DEFAULT_MIN_VERSION,
            latestVersion: '',
          });
        }
      } catch (error) {
        logError('Error retrieving minimum version from AsyncStorage:', error);
        // Use the default minimum if error in retrieving from AsyncStorage!!
        await compareVersions({
          minimumVersion: DEFAULT_MIN_VERSION,
          latestVersion: '',
        });
      }
      // return Promise.reject(error);
    });
};
